/**
 * *(Owner, 2026-10-12)* The two promise helpers PDF.js calls on every message, for iPhones that lack
 * them: `Promise.withResolvers` (iOS 17.4) and `Promise.try` (iOS 18.2).
 *
 * A student on an older iPhone saw every PDF fail with „მასალა ვერ ჩაიტვირთა“ while the server had
 * granted access: PDF.js 6 stops at the first call to a missing helper, and its legacy build covers
 * iOS 18.0 but not 17. Installed in the page (`pdf-engine.ts`) and in the worker (`pdf-worker.ts`),
 * only where the browser has no helper of its own.
 */
type PromiseStatics = {
  withResolvers?: <T>() => { promise: Promise<T>; resolve: (value: T | PromiseLike<T>) => void; reject: (reason?: unknown) => void };
  try?: <T>(action: (...args: unknown[]) => T | PromiseLike<T>, ...args: unknown[]) => Promise<T>;
};

const statics = Promise as unknown as PromiseStatics;

if (typeof statics.withResolvers !== 'function') {
  statics.withResolvers = <T>() => {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: unknown) => void;
    const promise = new Promise<T>((yes, no) => {
      resolve = yes;
      reject = no;
    });
    return { promise, resolve, reject };
  };
}

if (typeof statics.try !== 'function') {
  statics.try = <T>(action: (...args: unknown[]) => T | PromiseLike<T>, ...args: unknown[]) =>
    new Promise<T>((resolve) => {
      resolve(action(...args));
    });
}

export {};
